import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Feed from "./Feed";
import Conversations from "./Conversations";
import Matching from "./matching/Matching";
import Reseau from './Reseau'
import NativeSearch from './NativeSearch'
import PremiumReminderModal from "../premium/PremiumReminderModal";


export default function Dashboard() {


  const [selectedUsername, setSelectedUsername] = useState("");
  const [selectedUserPhoto, setSelectedUserPhoto] = useState(null);

  const [isConversationOpen, setIsConversationOpen] =
    useState(false);

  const [activeTab, setActiveTab] =
    useState("home");

  const [notificationRequest, setNotificationRequest] =
    useState(0);

  const [feedRefreshKey, setFeedRefreshKey] =
    useState(0);
  const feedScrollPositionRef = useRef(0);

  const [selectedUserId, setSelectedUserId] =
    useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {

    if (location.state?.openMessages) {

      setActiveTab("messages");

      setSelectedUserId(
        location.state.selectedUser
      );

      setSelectedUsername(
        location.state.selectedUsername || ""
      );

      setSelectedUserPhoto(
        location.state.selectedUserPhoto || null
      );

      navigate(
        location.pathname,
        {
          replace: true,
          state: {}
        }
      );

    }

  }, [location]);

  useEffect(() => {
    const requestedTab = new URLSearchParams(location.search).get("tab");
    const supportedTabs = ["home", "matching", "messages", "network", "search"];

    if (supportedTabs.includes(requestedTab)) {
      setActiveTab(requestedTab);
    }
  }, [location.search]);

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );
  }, []);

  const handleHomeNavigation = () => {
    if (activeTab !== "home") {
      setActiveTab("home");
      window.requestAnimationFrame(() => window.scrollTo({ top: feedScrollPositionRef.current, behavior: "auto" }));
      return;
    }
    setActiveTab("home");
    setFeedRefreshKey((value) => value + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleTabChange = (nextTab) => {
    if (nextTab === activeTab) return;
    if (activeTab === "home") feedScrollPositionRef.current = window.scrollY;
    setActiveTab(nextTab);
    if (nextTab === "home") {
      window.requestAnimationFrame(() => window.scrollTo({ top: feedScrollPositionRef.current, behavior: "auto" }));
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  };


  // useEffect(() => {


  //   if (location.state?.openMessages) {

  //     setActiveTab(
  //       "messages"
  //     );

  //     setSelectedUserId(
  //       location.state.selectedUser
  //     );

  //     navigate(
  //       location.pathname,
  //       {
  //         replace: true,
  //         state: {}
  //       }
  //     );

  //   }

  // }, [location]);

  return (
    <>

      <PremiumReminderModal />

      {!(isMobile && isConversationOpen) && (
        <Navbar
          activeTab={activeTab}
          setActiveTab={handleTabChange}
          onHomeNavigation={handleHomeNavigation}
          notificationRequest={notificationRequest}
        />
      )}
      {/* <Navbar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      /> */}

      <main
        className={activeTab === "home" ? "dashboard-main feed-canvas" : "dashboard-main"}
        style={{
          background: activeTab === "home" ? undefined : "#f0f2f5",
          minHeight: "100vh",
          paddingTop:
            isMobile && isConversationOpen
              ? "0"
              : "64px"
        }}
      >
        {/* <main
        style={{
          background: "#f0f2f5",
          minHeight: "100vh",
          paddingTop:
            isConversationOpen &&
              window.innerWidth <= 768
              ? "0"
              : "64px"
        }}
      > */}
        <div className={activeTab === "home" ? "dashboard-tab-panel active" : "dashboard-tab-panel"}>
          <Feed
            key={feedRefreshKey}
            onNavigate={handleTabChange}
            onOpenNotifications={() =>
              setNotificationRequest((value) => value + 1)
            }
          />
        </div>

        {activeTab === "matching" &&
          <Matching />
        }

        {activeTab === "messages" && (
          <Conversations
            selectedUserId={selectedUserId}
            selectedUsername={selectedUsername}
            selectedUserPhoto={selectedUserPhoto}
            onConversationOpen={setIsConversationOpen}
            onSelectedUserHandled={() => setSelectedUserId(null)}
          />
        )}

        {activeTab === "network" &&
          <Reseau />
        }

        {activeTab === "search" &&
          <NativeSearch />
        }

      </main>
    </>
  );
}
